/**
 * Generates a subtle corporate chime sound using Web Audio API.
 * A clean, professional two-tone ascending chime (~1.5s).
 */
export const playCorporateChime = () => {
  try {
    const ctx = new AudioContext();
    const master = ctx.createGain();
    master.gain.value = 0.18;
    master.connect(ctx.destination);

    const now = ctx.currentTime;

    // Note frequencies (C5, E5, G5 — a major chord arpeggio)
    const notes = [
      { freq: 523.25, start: 0, dur: 0.9 },    // C5
      { freq: 659.25, start: 0.25, dur: 0.8 },  // E5
      { freq: 783.99, start: 0.5, dur: 1.0 },   // G5
    ];

    notes.forEach(({ freq, start, dur }) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;

      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.6, now + start + 0.08);
      gain.gain.exponentialRampToValueAtTime(0.001, now + start + dur);

      osc.connect(gain);
      gain.connect(master);
      osc.start(now + start);
      osc.stop(now + start + dur);
    });

    // Soft shimmer overlay
    const shimmer = ctx.createOscillator();
    shimmer.type = "sine";
    shimmer.frequency.value = 1567.98; // G6
    const shimmerGain = ctx.createGain();
    shimmerGain.gain.setValueAtTime(0, now + 0.6);
    shimmerGain.gain.linearRampToValueAtTime(0.15, now + 0.75);
    shimmerGain.gain.exponentialRampToValueAtTime(0.001, now + 1.8);
    shimmer.connect(shimmerGain);
    shimmerGain.connect(master);
    shimmer.start(now + 0.6);
    shimmer.stop(now + 1.8);

    // Clean up context after sound finishes
    setTimeout(() => ctx.close(), 3000);
  } catch {
    // Silently fail if Web Audio is not available
  }
};
